import { IComponentKey } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

/**
 * 🎯 Purpose:
 * Defines the list of widget component keys that are of type narrative,
 * and their response is coming from socket.
 *
 * Used for tracking readiness of narrative widgets in reports.
 */

export const NARRATIVE_WIDGETS_IN_REPORT_COMPONENT_KEYS: IComponentKey[] = ['reportSummary', 'automatedNarrative'];
